var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("table", { staticClass: "tableClass" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "tbody",
      _vm._l(_vm.rows, function(row, index) {
        return _c(
          "tr",
          { staticClass: "Row", style: { backgroundColor: _vm.colors[index] } },
          [
            _c(
              "td",
              {
                staticClass: "thChildren",
                staticStyle: { "border-right": "2px dotted #67A0B4" }
              },
              [_vm._v("-")]
            ),
            _vm._v(" "),
            _c("td", { staticClass: "thChildren" }, [
              _vm._v(_vm._s(row.served.children.target.value))
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "thChildren" }, [
              _vm._v(_vm._s(row.served.children.server.value))
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "thChildren" }, [
              _vm._v(_vm._s(row.served.children.clients.value))
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "thChildren" }, [
              _vm._v(_vm._s(row.served.children.business.value))
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "thChildren" }, [
              _vm._v(_vm._s(row.served.children.private.value))
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "thChildren" }, [
              _vm._v(_vm._s(row.served.children.sum.value))
            ]),
            _vm._v(" "),
            _c(
              "td",
              {
                staticClass: "thChildren",
                staticStyle: { "border-right": "2px dotted #67A0B4" }
              },
              [_vm._v(_vm._s(row.served.children.in_percentage.value))]
            ),
            _vm._v(" "),
            _c("td", { staticClass: "thChildren" }, [
              _vm._v(_vm._s(row.revenue.children.npv.value))
            ]),
            _vm._v(" "),
            _c(
              "td",
              {
                staticClass: "thChildren",
                staticStyle: { "border-right": "2px dotted #67A0B4" }
              },
              [_vm._v(_vm._s(row.revenue.children.in_percentage.value))]
            ),
            _vm._v(" "),
            _c("td", { staticClass: "thChildren" }, [
              _vm._v(
                _vm._s(row.cost.children.street_sides.children.urban.value)
              )
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "thChildren" }, [
              _vm._v(
                _vm._s(row.cost.children.street_sides.children.rural.value)
              )
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "thChildren" }, [
              _vm._v(
                _vm._s(row.cost.children.street_crossings.children.urban.value)
              )
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "thChildren" }, [
              _vm._v(
                _vm._s(row.cost.children.street_crossings.children.rural.value)
              )
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "thChildren" }, [
              _vm._v(_vm._s(row.cost.children.private.value))
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "thChildren" }, [
              _vm._v(_vm._s(row.cost.children.rail_crossings.value))
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "thChildren" }, [
              _vm._v(_vm._s(row.cost.children.duct_potential.value))
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "thChildren" }, [
              _vm._v(_vm._s(row.cost.children.server.value))
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "thChildren" }, [
              _vm._v(_vm._s(row.cost.children.sum.value))
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "thChildren" }, [
              _vm._v(_vm._s(row.cost.children.in_percentage.value))
            ]),
            _vm._v(" "),
            _c(
              "td",
              {
                staticClass: "thChildren",
                staticStyle: { "border-right": "2px dotted #67A0B4" }
              },
              [_vm._v(_vm._s(row.cost.children.private.value))]
            ),
            _vm._v(" "),
            _c("td", { staticClass: "thChildren" }, [
              _vm._v(
                _vm._s(row.incremental_cost.children.delta.children.cost.value)
              )
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "thChildren" }, [
              _vm._v(
                _vm._s(row.incremental_cost.children.delta.children.npv.value)
              )
            ]),
            _vm._v(" "),
            _c(
              "td",
              {
                staticClass: "thChildren",
                staticStyle: { "border-right": "2px dotted #67A0B4" }
              },
              [
                _vm._v(
                  _vm._s(
                    row.incremental_cost.children.delta.children.per_npv.value
                  )
                )
              ]
            ),
            _vm._v(" "),
            _c("td", { staticClass: "thChildren" }, [
              _vm._v(
                _vm._s(row.length.children.street_sides.children.urban.value)
              )
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "thChildren" }, [
              _vm._v(
                _vm._s(row.length.children.street_sides.children.rural.value)
              )
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "thChildren" }, [
              _vm._v(
                _vm._s(
                  row.length.children.street_crossings.children.urban.value
                )
              )
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "thChildren" }, [
              _vm._v(
                _vm._s(
                  row.length.children.street_crossings.children.rural.value
                )
              )
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "thChildren" }, [
              _vm._v(_vm._s(row.length.children.private.value))
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "thChildren" }, [
              _vm._v(_vm._s(row.length.children.duct_potential.value))
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "thChildren" }, [
              _vm._v(_vm._s(row.length.children.sum.value))
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "thChildren" }, [
              _vm._v(_vm._s(row.length.children.in_percentage.value))
            ]),
            _vm._v(" "),
            _c(
              "td",
              {
                staticClass: "thChildren",
                staticStyle: { "border-right": "2px dotted #67A0B4" }
              },
              [_vm._v(_vm._s(row.length.children.per_npv.value))]
            ),
            _vm._v(" "),
            _c("td", { staticClass: "thChildren" }, [
              _vm._v(
                _vm._s(row.count.children.street_crossings.children.urban.value)
              )
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "thChildren" }, [
              _vm._v(
                _vm._s(row.count.children.street_crossings.children.rural.value)
              )
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "thChildren" }, [
              _vm._v(_vm._s(row.count.children.rail_crossings.value))
            ])
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "data-table-header" }, [
      _c("tr", { staticClass: "topHeader" }, [
        _c("th", { staticClass: "thChildren" }, [_vm._v("Topology")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("Served")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("Revenue")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("Cost")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("Increment Cost")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("Length")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("Count")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" })
      ]),
      _vm._v(" "),
      _c("tr", { staticClass: "middleHeader" }, [
        _c(
          "th",
          {
            staticClass: "thChildren",
            staticStyle: { "border-right": "2px dotted #67A0B4" }
          },
          [_vm._v("AREA")]
        ),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("TARGET")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("SERVER")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("CLIENTS")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("BUSINESS")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("PRIVATE")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("SUM")]),
        _vm._v(" "),
        _c(
          "th",
          {
            staticClass: "thChildren",
            staticStyle: { "border-right": "2px dotted #67A0B4" }
          },
          [_vm._v("IN %")]
        ),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("NPV")]),
        _vm._v(" "),
        _c(
          "th",
          {
            staticClass: "thChildren",
            staticStyle: { "border-right": "2px dotted #67A0B4" }
          },
          [_vm._v("IN %")]
        ),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("STREET SIDES")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("STREET CROSSINGS")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("PRIVATE")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("RAIL CROSSINGS")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("DUCT POTENTIAL")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("SERVER")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("SUM")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("IN %")]),
        _vm._v(" "),
        _c(
          "th",
          {
            staticClass: "thChildren",
            staticStyle: { "border-right": "2px dotted #67A0B4" }
          },
          [_vm._v("PER NPV")]
        ),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("DELTA")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", {
          staticClass: "thChildren",
          staticStyle: { "border-right": "2px dotted #67A0B4" }
        }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("STREET SIDES")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("STREET CROSSINGS")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("PRIVATE")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("DUCT POTENTIAL")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("SUM")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("IN %")]),
        _vm._v(" "),
        _c(
          "th",
          {
            staticClass: "thChildren",
            staticStyle: { "border-right": "2px dotted #67A0B4" }
          },
          [_vm._v("PER NPV")]
        ),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("STREET CROSSINGS")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("RAIL CROSSINGS")])
      ]),
      _vm._v(" "),
      _c("tr", { staticClass: "bottomHeader" }, [
        _c("th", {
          staticClass: "thChildren",
          staticStyle: { "border-right": "2px dotted #67A0B4" }
        }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", {
          staticClass: "thChildren",
          staticStyle: { "border-right": "2px dotted #67A0B4" }
        }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", {
          staticClass: "thChildren",
          staticStyle: { "border-right": "2px dotted #67A0B4" }
        }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("Urban")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("Rural")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("Urban")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("Rural")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", {
          staticClass: "thChildren",
          staticStyle: { "border-right": "2px dotted #67A0B4" }
        }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("Cost")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("NPV")]),
        _vm._v(" "),
        _c(
          "th",
          {
            staticClass: "thChildren",
            staticStyle: { "border-right": "2px dotted #67A0B4" }
          },
          [_vm._v("PER NPV")]
        ),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("Urban")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("Rural")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("Urban")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("Rural")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }),
        _vm._v(" "),
        _c("th", {
          staticClass: "thChildren",
          staticStyle: { "border-right": "2px dotted #67A0B4" }
        }),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("Urban")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" }, [_vm._v("Rural")]),
        _vm._v(" "),
        _c("th", { staticClass: "thChildren" })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41dcc79c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41dcc79c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Npv/Configuration/components/AtesioTable.vue
// module id = null
// module chunks = 